import React from "react";

import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const icon = require("../../../assets/Detasad Cloud/main_icon_highperformance.svg");
const enterpriselevel = require("../../../assets/icons-pack//3.1 Elastic Computer Server/ic_01_enterpriselevel.svg");
const easyofuse = require("../../../assets/icons-pack/3.4 Elastic Kubernetes Services/ic_01_easyofuse.svg");

const Encryption = () => {
    const heading = `ENCRYPTION `;
    const details = `Do you know the value of your data on the Dark Web? Encrypt your data NOW with DETASAD Encryption Services for safety and security.`;

    const overview = [
        `DETASAD provides its customer the data encryption service. It covers Key Management Service (KMS) and HSM with monthly and yearly subscription models.`
    ];

    const advantages = [
        [
            `Regulatory Compliance`,
            `With DETASAD’s Encryption Service, keys and random numbers are generated by the third-party validated HSMs. It is compliant with local and international laws and regulations.`,
            icon
        ],
        [
            `Secure`,
            `DETASAD’s Encryption Service provides KPS that enables you to create or import key pairs on the management console when logging in to your purchased Elastic Cloud Server (ECS).`,
            enterpriselevel
        ],
        [
            `Easy Management`,
            `Encryption may sound complicated but DETASAD provides easier encryption controls to ensure that businesses can easily secure their data without any complications.`,
            icon
        ],
        [
            `Easy Integration`,
            `DETASAD’s Encryption Service provides KMS, integrated with many of the DETASAD Cloud’s extensive services including Object Storage Service (OBS), Elastic Volume Service (EVS), Image Management Service (IMS), and more.`,
            easyofuse
        ]
    ];

    const functions = [
        [
            `Key Management Service`,
            [
                `DETASAD Encryption provides Key Management Service (KMS) using a multi-tenant HSMs, an offering that is compatible and integrates with many of DETASAD Cloud wide-ranging services including OSS, EVS and more. APIs are also supported, so you can call APIs to integrate KMS with your applications to encrypt data.`
            ]
        ],
        [
            `Dedicated HSM `,
            [
                `DETASAD provides dedicated HSM which guarantees high-performance encryption to meet your stringent security requirements using different encryption protocols.`
            ]
        ],
        [
            `Key Pair Service`,
            [
                `KPS is designed for login scenarios that have stringent security requirements. When purchasing an ECS, you can set the login mode to key-pair login. The key pair can be reset or replaced as necessary.`
            ]
        ]
    ];
    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-security"/>
            <SubNav overview={overview} advantages={advantages} functions={functions} />
            <Footer />
        </div>
    );
};

export default Encryption;
